import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { Button } from '../UiKit/Button';
import { Icon } from '../UiKit/Icon';

export function PentaModeSwitch({ compare, setCompare, memberCount }) {
  const { $ui } = useContext(LangContext);
  if (memberCount >= 3 || !setCompare) return null;

  return (
    <div className="x_penta_view0 _fgap0">
      <Button
        sm
        tooltip={$ui('penta_switch_composite')}
        tooltipPlacement="bottom"
        tooltipMobileOff
        className={`x_penta_view x_penta_view_composite ${!compare ? 'active' : ''}`}
        onClick={() => setCompare(false)}
      >
        <Icon style={{ opacity: !compare ? 1 : 0.5 }}>
          group
        </Icon>
      </Button>
      <Button
        sm
        tooltip={$ui('penta_switch_side')}
        tooltipPlacement="bottom"
        tooltipMobileOff
        className={`x_penta_view x_penta_view_compare ${compare ? 'active' : ''}`}
        onClick={() => setCompare(true)}
      >
        <Icon style={{ opacity: compare ? 1 : 0.5 }}>
          compare
        </Icon>
      </Button>
    </div>
  );
}
